import { ApiManager } from 'utlis/api_manager';

const api = new ApiManager(process.env.REACT_APP_BASE_URL, 1);
const workspacesUrl = 'project/team/workspaces';

export const getWorkspaces = async () => {
  const { data } = await api.setUrl(workspacesUrl).get();

  return data.results ?? [];
};

export const getWorkspace = async uuid => {
  const { data } = await api.setUrl(workspacesUrl).getByKey(uuid);

  return data;
};

export const createWorkspace = async (name, avatarUrl = null) => {
  const payload = { name };

  if (avatarUrl) {
    payload.avatar_url = avatarUrl;
  }

  const { data } = await api.setUrl(workspacesUrl).post(payload);

  return data;
};

export const updateWorkspace = async (uuid, payload, signal = null) => {
  const { data } = await api
    .setUrl(workspacesUrl)
    .patch(uuid, payload, signal ? { signal } : {});

  return data;
};

export const syncWebDashboard = async () => {
  const { data } = await api.setUrl('project/team/web-dashboard/sync').post({});

  return data;
};
